import { PROYECT, api_put, } from "services/api";
import { setSnackbar, } from "../search/searchActions";
import { configChangeTypes } from "redux/reducers/configChange/types"
const { GET_CONFIG_CHANGE, SET_CONFIG_CHANGE_FILTERS } = configChangeTypes

const url = `${process.env.REACT_APP_URL}${PROYECT}/support/edit_config`

export const putConfigChange = (form, setOpen) => {
    return async (dispatch) => {
        await api_put(url, form).then(async (resp) => {
            if (resp?.oldConfig[0]?.value) {
                dispatch(setSnackbar(`Serie anterior: ${resp?.oldConfig[0]?.value}, actual: ${resp?.newConfig[0]?.value}. 
                    Estacionario anterior: ${resp?.oldConfig[1]?.value}, actual: ${resp?.newConfig[1]?.value}`, "success"))
            }
            else {
                dispatch(setSnackbar("Cambios aplicados", "success"))
            }
            setOpen()
        }).catch(err => {
            dispatch(setSnackbar(err))
        })
    }
}

export const setConfigChangeFilters = (key = "", value) => {
    return {
        type: SET_CONFIG_CHANGE_FILTERS,
        payload: { value, key }
    }
}